import { useState } from "react";

type AlertType = "success" | "error" | "loading" | "confirm";

interface AlertConfig {
  open: boolean;
  type: AlertType;
  message: string;
  title: string;
  onConfirm: (() => Promise<void>) | undefined;
}

export const useAlertManager = () => {
  const [alertConfig, setAlertConfig] = useState<AlertConfig>({
    open: false,
    type: "success",
    message: "",
    title: "",
    onConfirm: undefined,
  });

  const showSuccess = (message: string, title: string = "Éxito") => {
    setAlertConfig({
      open: true,
      type: "success",
      message,
      title,
      onConfirm: undefined,
    });
  };

  const showError = (message: string, title: string = "Error") => {
    setAlertConfig({
      open: true,
      type: "error",
      message,
      title,
      onConfirm: undefined,
    });
  };

  const showLoading = (message: string, title: string = "") => {
    setAlertConfig({
      open: true,
      type: "loading",
      message,
      title,
      onConfirm: undefined,
    });
  };

  const showConfirm = (message: string, title: string, onConfirm: () => Promise<void>) => {
    setAlertConfig({
      open: true,
      type: "confirm",
      message,
      title,
      onConfirm,
    });
  };

  const closeAlert = () => {
    setAlertConfig((prev) => ({ ...prev, open: false }));
  };

  const resetAlert = () => {
    setAlertConfig({
      open: false,
      type: "success",
      message: "",
      title: "",
      onConfirm: undefined,
    });
  };

  return {
    alertConfig,
    setAlertConfig,
    showSuccess,
    showError,
    showLoading,
    showConfirm,
    closeAlert,
    resetAlert
  };
};